import { Navigate, useLocation } from "react-router-dom";

/**
 * Compat : les anciennes URLs prefixees `/v2/*` sont redirigees vers `/*`.
 * Le prefixe de version n'existe plus dans les URLs ;
 * cette redirection preserve les anciens liens et favoris.
 */
const RedirectLegacyVersion = () => {
    const location = useLocation();
    const stripped = location.pathname.replace(/^\/v2(?=\/|$)/, '') || '/';
    const targetUrl = `${stripped}${location.search}${location.hash}`;
    const currentUrl = `${location.pathname}${location.search}${location.hash}`;
    if (targetUrl === currentUrl) return null;
    return <Navigate to={targetUrl} replace />;
};

export default RedirectLegacyVersion;
